/**
 * @generated SignedSource<<741593873e476aa21de3e1bda59c873d>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { InlineFragment, ReaderInlineDataFragment } from 'relay-runtime';
export type NftTokenContractImportStatus = "NFT_TOKEN_CONTRACT_IMPORT_STATUS_COMPLETE" | "NFT_TOKEN_CONTRACT_IMPORT_STATUS_ERROR" | "NFT_TOKEN_CONTRACT_IMPORT_STATUS_PROCESSING" | "%future added value";
import { FragmentRefs } from "relay-runtime";
export type importCollectionsConfig_contractImport$data = {
  readonly completed: {
    readonly totalResults: number | null;
  } | null;
  readonly errored: {
    readonly totalResults: number | null;
  } | null;
  readonly importStatus: NftTokenContractImportStatus | null;
  readonly processing: {
    readonly totalResults: number | null;
  } | null;
  readonly serviceId: string | null;
  readonly " $fragmentType": "importCollectionsConfig_contractImport";
};
export type importCollectionsConfig_contractImport$key = {
  readonly " $data"?: importCollectionsConfig_contractImport$data;
  readonly " $fragmentSpreads": FragmentRefs<"importCollectionsConfig_contractImport">;
};

const node: ReaderInlineDataFragment = {
  "kind": "InlineDataFragment",
  "name": "importCollectionsConfig_contractImport"
};

(node as any).hash = "e6b6257ae68b1f09c3f69b30b229b465";

export default node;
